import { Button, Descriptions, Dropdown, Popconfirm } from "antd";
import { Link, useNavigate, useRouteLoaderData } from "react-router";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import BackTitle from "../common/BackTitle";
import { api } from "../common/api";

export default function DpiProduct() {
  const data = useRouteLoaderData("dpiProduct");
  const navigate = useNavigate();

  return (
    <div style={{ width: "100%" }}>
      <BackTitle
        backEnabled={false}
        title="Dettagli prodotto DPI"
        secondary={`ID: ${data.id}`}
        extra={
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  key: "delete",
                  danger: true,
                  icon: <DeleteOutlined />,
                  label: (
                    <Popconfirm
                      title="Conferma rimozione"
                      description="L'operazione è irreversibile. Procedendo, i dati verranno rimossi definitivamente."
                      onConfirm={() => api.dpiProduct.delete(data.id).then(() => navigate(".."))}
                    >
                      Elimina
                    </Popconfirm>
                  ),
                },
              ],
            }}
          >
            <Button aria-label="Azioni prodotto DPI" icon={<MoreOutlined />} />
          </Dropdown>
        }
      />
      <Descriptions
        colon={false}
        column={2}
        title={
          <>
            Informazioni generali
            <Button
              type="link"
              aria-label="Modifica prodotto DPI"
              icon={<EditOutlined />}
              onClick={() => navigate("edit")}
            />
          </>
        }
        items={[
          {
            key: "dpi",
            label: "Categoria",
            children: data.dpi && <Link to={`/dpis/${data.dpi.id}`}>{data.dpi.name}</Link>,
          },
          { key: "description", label: "Descrizione", children: data.description },
          { key: "supplier", label: "Fornitore", children: data.supplier },
          { key: "supplierCode", label: "Cod. articolo fornitore", children: data.supplierCode },
          { key: "sku", label: "SKU", children: data.sku },
          { key: "color", label: "Colore", children: data.color },
          { key: "size", label: "Taglia", children: data.size },
          { key: "inventoryAmount", label: "Giacenza", children: data.inventoryAmount ?? 0 },
        ]}
      />
    </div>
  );
}
